// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeaturesTypeFourth_feature__11p_g","title":"FeaturesTypeFourth_title__zPz01","col":"FeaturesTypeFourth_col__3numm","leftCol":"FeaturesTypeFourth_leftCol__3WFHU"};